<template>
    <div class="w-full">
        <label
            v-if="label"
            :for="inputId"
            class="block mb-1 text-sm text-theme-muted font-semibold"
        >
            {{ label }}
        </label>
        <textarea
            :id="inputId"
            ref="textarea"
            v-bind="$attrs"
            :value="value"
            :placeholder="placeholder"
            :disabled="disabled"
            :rows="rows"
            class="w-full resize-none rounded-md border bg-theme-input text-theme-base px-3 py-2 text-sm transition-colors focus:outline-none focus:ring-1"
            :class="[
                error
                    ? 'border-theme-danger focus:ring-theme-danger'
                    : 'border-theme-border focus:ring-theme-primary',
                disabled
                    ? 'opacity-80 cursor-not-allowed text-theme-disabled'
                    : ''
            ]"
            @input="$emit('input', $event.target.value)"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
        ></textarea>
        <p v-if="error" class="mt-1 text-xs text-theme-danger">
            {{ error }}
        </p>
    </div>
</template>

<script>
export default {
    name: "CustomTextarea",
    inheritAttrs: false,
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            default: () => "",
            type: String,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        placeholder: {
            default: () => "",
            type: String,
            required: false
        },
        error: {
            default: () => "",
            type: String,
            required: false
        },
        disabled: {
            default: () => false,
            type: Boolean,
            required: false
        },
        rows: {
            default: () => 4,
            type: [String, Number],
            required: false
        },
        id: {
            default: () => "",
            type: String,
            required: false
        }
    },
    emits: ["input", "focus", "blur"],
    computed: {
        inputId() {
            return this.id || `custom-textarea-${this._uid}`;
        }
    }
};
</script>
